"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isMessageDescriptor = (function (x) {
    return x &&
        typeof x.id === 'string' &&
        typeof x.defaultMessage === 'string';
});
exports.default = (function (t) {
    return (function (key, options) {
        return isMessageDescriptor(key) ? t(key.id, key.defaultMessage, options) : t(key, options);
    });
});
